import { createAction, props } from '@ngrx/store';
import { ControllableObjectsModel } from '../models/app/controllable-objects';

export const loadControllableObjects = createAction('[ControllableObjects] Load');

export const controllableObjectsLoaded = createAction('[ControllableObjects] Loaded', props<{ objectList: any[] }>());
